import { render, staticRenderFns } from "./weddingGallery.vue?vue&type=template&id=50de2154&"
import script from "./weddingGallery.vue?vue&type=script&lang=js&"
export * from "./weddingGallery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports